import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { pathnameToAuthPageId } from './authPageStories';

interface AuthPageFrameProps {
  children: React.ReactNode;
}

/** Single-viewport auth page wrapper — no scroll narrative blocks */
const AuthPageFrame: React.FC<AuthPageFrameProps> = ({ children }) => {
  const { pathname } = useLocation();
  const pageId = pathnameToAuthPageId(pathname);

  return (
    <motion.div className="w-full min-h-0" data-auth-page={pageId} layout={false}>
      {children}
    </motion.div>
  );
};

export default AuthPageFrame;
